export const DEFAULT_PAGE_SIZE = 25
export const EXTENDED_PAGE_SIZE = 50
export const SMALL_PAGE_SIZE = 5
export const MAX_PAGE_SIZE = 200

// Rozszerzony zestaw rozmiarów strony dla list, których backend przyjmuje page[size] do 200.
export const EXTENDED_PER_PAGE_OPTIONS = [10, 25, 50, 100, 200]
